import { GetMessageList } from '@/api/message';
import Message from '@/utils/message';
import mqtt from 'mqtt';
let message = new Message();

let wsPrefix = location.protocol.includes('https') ? 'wss://' : 'ws://';
let href = process.env.VUE_APP_MESSAGE_URL;
let localWs = process.env.NODE_ENV === 'development' ? 'wss://' : wsPrefix;

let URL =
  process.env.NODE_ENV === 'development'
    ? `${localWs}${href}/emq_websocket/mqtt`
    : `${wsPrefix}${location.hostname}/emq_websocket/mqtt`;

const state = {
  lockReconnect: false, //避免ws重复连接
  reconnectNum: 0,
  ws: null,
  wsUrl: URL,
  timeout: 15000, //1秒发一次心跳
  timeoutObj: null,
  serverTimeoutObj: null,
  unreadMsgData: {}, //未读消息数据
  importMsg: {},
  importMsgArr: [],
  lockHand: false
};

const mutations = {
  setUnreadData(state, value) {
    state.unreadMsgData = value;
  },
  // 消息置为已读
  setMsgReaded(state, value) {
    let match = state.unreadMsgData.list.find(item => item.id === value.id);
    match && (match.message_status = 1);
  }
};

const actions = {
  resetHeart({ commit, state }) {
    clearTimeout(state.timeoutObj);
    clearTimeout(state.serverTimeoutObj);
  },
  startHeart({ commit, state }) {
    state.timeoutObj = setTimeout(() => {
      //这里发送一个心跳，后端收到后，返回一个心跳消息，
      //onmessage拿到返回的心跳就说明连接正常
      state.ws.send('ping');
      state.serverTimeoutObj = setTimeout(() => {
        //如果超过一定时间还没重置，说明后端主动断开了
        state.ws.close(); //如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
      }, 30000);
    }, state.timeout);
  },
  createWebSocket({ dispatch, commit, state, rootState }) {
    // if ('WebSocket' in window) {
    //   let token = localStorage.getItem('token');
    //   state.ws = new WebSocket(state.wsUrl, [token]);

    //   // WebSocket事件方法
    //   dispatch('initEventHandle');
    // } else {
    //   alert('您的浏览器不支持websocket');
    // }
    const options = {
      clientId: 'BaigeWs|' + ('' + new Date().getTime()),
      username: localStorage.getItem('token'),
      autoReconnect: true
    };
    state.ws = mqtt.connect(URL, options);
    dispatch('initEventHandle');
  },
  initEventHandle({ dispatch, commit, state, rootState }) {
    // state.ws.onopen = () => {
    //   //心跳检测重置
    //   dispatch('resetHeart');
    //   dispatch('startHeart');
    //   console.log(`websocket 已连接：时间-${new Date().toLocaleString()}`);
    // };

    // //获得消息事件
    // state.ws.onmessage = evt => {
    //   //如果获取到消息，心跳检测重置
    //   dispatch('resetHeart');
    //   dispatch('startHeart');

    //   if (evt.data !== 'pong') {
    //     let { data } = evt;
    //     data = JSON.parse(data);
    //     if (data.type) {
    //       state.importMsg = data;
    //       console.log(data, '消息推送');
    //       if (data.type !== 9) {
    //         //9就是设备导入 不需要提示框
    //         dispatch('getUnreadMsgList');
    //         message.handleMessageFn(data);
    //       }
    //     }
    //   }
    // };

    // state.ws.onerror = () => {
    //   console.log(`WebSocket 连接错误：时间-${new Date().toLocaleString()}`);
    //   dispatch('reconnect');
    // };

    // state.ws.onclose = e => {
    //   console.log(
    //     `websocket 连接断开: 断开时间-${new Date().toLocaleString()} 状态码-${e.code} 断开原因-${e.reason
    //     } 是否正常断开-${e.wasClean}`
    //   );
    //   dispatch('reconnect');
    // };
    state.ws.on('connect', () => {
      state.ws.subscribe(`Baige/message/user_${rootState.user.userInfo.user_id}`, { qos: 0 }, error => {
        error && console.log(error, 'error-connect');
      });
    });
    state.ws.on('message', (topic, msg) => {
      if (topic === `Baige/message/user_${rootState.user.userInfo.user_id}`) {
        const data = JSON.parse(msg.toString());
        if (data.type) {
          if (data.type !== 9) {
            //9就是设备导入 不需要提示框
            if (!state.lockHand) {
              state.lockHand = true;
              setTimeout(() => {
                state.lockHand = false;
                const unReadMsgLength = state.unreadMsgData.list
                  ? state.unreadMsgData.list.filter(item => item.message_status !== 1).length
                  : 0;
                unReadMsgLength === 0 && dispatch('getUnreadMsgList');
                message.handleMessageFn(data);
              }, 1000);
            }
          } else if (data.type === 9) {
            let message = JSON.parse(data.message);
            let import_res = message.import_res;
            state.importMsgArr.push(import_res);
            if (import_res.res === 3) {
              state.importMsg = data;
              setTimeout(() => {
                state.importMsgArr = [];
              }, 10000);
            }
          }
        }
      }
    });
    state.ws.on('error', error => {
      console.log(error, 'error-error');
    });
  },
  reconnect({ dispatch, commit, state }) {
    state.reconnectNum++;
    // 限制重连次数，防止一直重连
    if (state.reconnectNum > 10) return;
    if (state.lockReconnect) return;
    state.lockReconnect = true;

    console.log(`尝试重连第${state.reconnectNum}次，时间-${new Date().toLocaleString()}`);

    // 没连接上会一直重连，设置5s延迟避免请求过多
    setTimeout(() => {
      dispatch('createWebSocket');
      state.lockReconnect = false;
    }, 5000);
  },
  // 获取未读消息列表
  getUnreadMsgList({ commit, state }) {
    return new Promise(resolve => {
      GetMessageList(
        {
          status: 2,
          page: 1,
          page_size: 100
        },
        true
      ).then(res => {
        if (res) {
          commit('setUnreadData', res.data);
        }
        resolve();
      });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
